import Footnote from './Footnote';
export { Footnote };
export default Footnote;
